import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/styles';
import { Card } from "@material-ui/core";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
 
}));
function HVACReport() {
  const classes = useStyles();
  const history = useHistory();
  const [roleTypes, setRoleTypes] = useState(0);
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  


  return (
    <Page
      className={classes.root}
      title={"Enerji Çözümleri"}
    >
      Raporlar
    </Page>
  );
}

export default HVACReport;
